export default __webpack_public_path__ + "static/media/misc-closet2-768w.7d5aacf9.png";